import Enum from "../../../../../enums/Enum";

const TreatmentInfoEnum = new Enum({
    TREATMENT_RECEIVED: {title: "Treatment Received"},
    TREATMENT_PLAN: {title: "Treatment Plan"},
});

export default TreatmentInfoEnum;